
const initialState : ReportState = {
    reportData: null,  // Or some default value
    loading: false,   // Or some default value
  };
  interface ReportState {
    reportData: any | null; // Replace 'any' with the actual type of your report data
    loading: boolean;
  }
  export default function volumeReport(state = initialState, action: any) : ReportState{
    switch (action.type) {
      case 'RECEIVE_VOLUME_REPORT':
        return {
          ...state,
          reportData: action.report,
          loading: action.loading,
        };
      case 'SET_VOLUME_REPORT_LOADING':
        return {
          ...state,
          loading: action.loading,
        };
      default:
        return state;
    }
  }
  